import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetSQuizQuery, usePostQuizMutation, useUpdateQuizMutation } from '../../features/quiz/quizApi';
import { useGetAllVideosQuery } from '../../features/video/videoApi';


const AddQuiz = () => {


 


    const {id: videoId } = useParams()
    const [videoData, setVideoData] = useState({options:[{id:1,"isCorrect": false},{id:2 , "isCorrect": false},{id:3 ,"isCorrect": false},{id: 4, "isCorrect": false}]});
    const {data:allVideo}=useGetAllVideosQuery()

    const { data: getVideo, isLoading: getLoading, isError: getIsError, error: getError } =  useGetSQuizQuery(videoId, { skip: !videoId });
    const navigate = useNavigate();


    useEffect(() => {
        setVideoData({ ...videoData,...getVideo })
    }, [getVideo])

    const handleChangeInput = (event,Optionvalue) => {
       
        const { name, value ,type} = event.target;
       
        setVideoData(prev => ({ ...prev, [name]: Optionvalue ? prev?.options?.map((it,index)=>index + 1 ==Optionvalue.id ? type=='radio'? {...it,isCorrect:true } : {...it,...Optionvalue } :  type=='radio'? {...it,isCorrect:false  } : it) : value }))
    }
    const [postQuizFunc, { isLoading, data, isSuccess, isError, error }] = usePostQuizMutation();
    const [updateVideoFunc, { isLoading: updateLoading, data: updateData, isSuccess: updateIsSuccess, isError: updateIsError, error: updateError }] = useUpdateQuizMutation();
    const handleSubmit = (e) => {
        e.preventDefault();

        if (videoId) {
            updateVideoFunc({ id: videoId, data: {...videoData,video_title:allVideo?.find(v=>v.id==videoData?.video_id)?.title} })

        } else {

            postQuizFunc({...videoData,video_title:allVideo?.find(v=>v.id==videoData?.video_id)?.title})
        }
    }
    useEffect(() => {
        if (isSuccess || updateIsSuccess) {
            navigate('/admin/quizs')
        }
    }, [updateIsSuccess, isSuccess])
    return (
        <>

            <section className="py-6 bg-primary h-screen grid place-items-center">
                <div className="mx-auto max-w-md px-5 lg:px-0 " style={{ width: '600px' }}>
                    <div>

                        <h2 className="mt-6 text-center text-3xl font-extrabold text-slate-100">
                            Add Quiz
                        </h2>
                    </div>
                    <form className="mt-8 space-y-6" action="#" method="POST" onSubmit={handleSubmit}>
                        <input type="hidden" name="remember" value="true" />
                        <div className="rounded-md shadow-sm -space-y-px">
                            <div>
                                <label htmlFor="name" className="sr-only">Question</label>
                                <input onChange={handleChangeInput} id="name" value={videoData?.question} name="question" type="name" autoComplete="name" required className="login-input rounded-t-md" placeholder="Question" />
                            </div>

                            <div>
                                <label htmlFor="name" className="sr-only">Video Title</label>
<select value={videoData?.video_id} onChange={handleChangeInput} name="video_id" className="login-input rounded-t-md">
    <option value="">Choose</option>
   
  {allVideo?.map(video=>( <option key={video?.id} value={video?.id}>{video?.title}</option>))}
</select>

                           
                            </div>

                            <div>
                                <label htmlFor="name" className="sr-only">Options One</label>
                                <input value={videoData.options[0].option}  onChange={e=>handleChangeInput(e,{id:1,option:e.target.value})} id="name" name="options"  type="text" autoComplete="name" required className="login-input rounded-t-md" placeholder="Options One" />
                                <input type="radio" id="html"  checked={videoData.options[0].isCorrect==true}   onChange={e=>handleChangeInput(e,{id:1,isCorrect:e.target.checked})}  name="options" value="1" />
 
                                <span>Correct Answer</span>
                              
                            </div>
                            <div>
                                <label htmlFor="name" className="sr-only">Options Two</label>
                                <input  value={videoData.options[1].option}  onChange={e=>handleChangeInput(e,{id:2,option:e.target.value})} id="name"   name="options"   type="text"   autoComplete="name" required className="login-input rounded-t-md" placeholder="Options Two" />

                                <input type="radio" id="html"    checked={videoData.options[1].isCorrect==true}   onChange={e=>handleChangeInput(e,{id:2,isCorrect:e.target.checked})}  name="options" value="2" />
 
                              <span>Correct Answer</span>
                              
                            </div>
                            <div>
                                <label htmlFor="name" className="sr-only">Options Three</label>
                                <input  value={videoData.options[2].option} onChange={e=>handleChangeInput(e,{id:3,option:e.target.value})} id="name"   name="options"   type="text" autoComplete="name" required className="login-input rounded-t-md" placeholder="Options Three" />
                                <input type="radio" id="html"   checked={videoData.options[2].isCorrect==true}     onChange={e=>handleChangeInput(e,{id:3,isCorrect:e.target.checked})}  name="options" value="3" />
 
                                <span>Correct Answer</span>
                              
                            </div>
                            <div>
                                <label htmlFor="name" className="sr-only">Options Four</label>
                                <input  value={videoData.options[3].option}   onChange={e=>handleChangeInput(e,{id:4,option:e.target.value})} id="name"   name="options"   type="text" autoComplete="name" required className="login-input rounded-t-md" placeholder="Options Four" />
                                <input type="radio" id="html"   checked={videoData.options[3].isCorrect==true}    onChange={e=>handleChangeInput(e,{id:4,isCorrect:e.target.checked})}  name="options" value="4" />
 
                                <span>Correct Answer</span>
                              
                            </div>

                            <>
                            <div>
 
</div>

                            </>

                        </div>
                        <div>
                            <button disabled={isLoading||updateLoading} type="submit" className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500">
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </section>

        </>
    )
}

export default AddQuiz